(function ($){
    var bodyHeight, blockHeight, scrollBtn, currentTop;
    var body = document.body;
    var html = document.documentElement;
    if($('.the-page-block').length > 0 || $('.the-top-block').height > 0){
        var blockTopHeight = 0;
        var blockPageHeight = 0;
        if($('.the-top-block').length > 0){
            blockTopHeight = getHeightBlockByElementString('.the-top-block');
        }
        if($('.the-page-block').length > 0){
            blockPageHeight = getHeightBlockByElementString('.the-page-block');
        }
        blockHeight = Math.max(blockTopHeight, blockPageHeight);
        if(blockHeight > 0){
            //set position slider left content
            var positionTop = computePositionTopSliderContent(blockHeight);
            setPositionSliderContent(positionTop, blockPageHeight, blockTopHeight);
            //end

            bodyHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
            scrollBtn = $('.scroll-down-view');

            //catch event on click
            scrollBtn.on('click', function(e, param){
                var timeout = 1000;
                var that = $(this);
                currentTop = $(document).scrollTop();
                bodyHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
                var bodyWidth = Math.max(body.offsetWidth, html.clientWidth, html.offsetWidth);
                var currentPage = Math.floor(currentTop/blockHeight);
                var nextPage = 0;
                if(param && param.nav){
                    nextPage = currentPage;
                }else{
                    // var nextPage = ++currentPage;
                    nextPage = ++currentPage;
                }
                event.preventDefault();
                if(param && param.time){
                    timeout = param.time;
                }
                if(e.currentTarget.parentElement.id == 'shareholding-management-portfolio-page'){
                    if((nextPage-1)*blockHeight + e.currentTarget.parentElement.clientHeight >= bodyHeight-$('.site-footer').outerHeight()){
                        $('html, body').animate({
                            scrollTop: (nextPage-2)*blockHeight + e.currentTarget.parentElement.clientHeight
                        }, timeout, function() {});
                    }
                    else{
                        $('html, body').animate({
                            scrollTop: (nextPage-1)*blockHeight + e.currentTarget.parentElement.clientHeight
                        }, timeout, function() {});
                    }
                }
                else {
                    $('html, body').animate({
                        scrollTop: nextPage*blockHeight
                    }, timeout, function() {});
                }
            });

            //catch event on change size view
            $(window).resize(function(e){
                var blockTopHeight = 0;
                var blockPageHeight = 0;
                if($('.the-top-block').length > 0){
                    blockTopHeight = getHeightBlockByElementString('.the-top-block');
                }
                if($('.the-page-block').length > 0){
                    blockPageHeight = getHeightBlockByElementString('.the-page-block');
                }
                blockHeight = Math.min(blockTopHeight, blockPageHeight);
                bodyHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
                
                //set position slider left content
                var positionTop = computePositionTopSliderContent(blockHeight);
                setPositionSliderContent(positionTop, blockPageHeight, blockTopHeight);
                //end
            });

            $( window ).on( "orientationchange", function( event ) {
                var blockTopHeight = 0;
                var blockPageHeight = 0;
                if($('.the-top-block').length > 0){
                    blockTopHeight = getHeightBlockByElementString('.the-top-block');
                }
                if($('.the-page-block').length > 0){
                    blockPageHeight = getHeightBlockByElementString('.the-page-block');
                }
                blockHeight = Math.min(blockTopHeight, blockPageHeight);
                bodyHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
                
                //set position slider left content
                var positionTop = computePositionTopSliderContent(blockHeight);
                setPositionSliderContent(positionTop, blockPageHeight, blockTopHeight);
            });
        }
    }

    function getHeightBlockByElementString(name){
        return $(name).outerHeight();
    }

    function computePositionTopSliderContent(blockHeight){
        return blockHeight - blockHeight*0.30 - 108;
    }

    function setPositionSliderContent(positionTop, blockPageHeight, blockTopHeight){
        $('.slider-container-content').css('display', 'block');
        // $('.slider-container-content').each(function(index, el){
        //     if(index == 0){
        //         el.style.top = (Math.min(blockPageHeight, blockTopHeight)*0.70 - 108) +'px';
        //     }
        //     else {
        //         el.style.top = positionTop+'px';
        //     }
        // });
    }

})(jQuery);